<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <div v-html="upgraded_content">
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import axios from 'axios'

export default {
  name: 'reservation-tnc-view',
  metaInfo () {
    return { title: this.$t('reservations') }
  },
  data () {
    return {
      articles: [],
      upgraded_content: ''
    }
  },
  components: {
    'page-title': PageTitle
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'restaurantContact', 'restaurantAddress', 'openingHours', 'reservationConfig', 'rid',
      'posType', 'loyaltyGroupId', 'epayAccount'
    ]),
    ...mapGetters('auth', [
      'authenticated'
    ]),
    ...mapGetters('member', [
      'isMember', 'membership', 'membershipConfig', 'activeOrderMembership','activeOrderPaymentsMembership',
      'profile'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    aboutStyle () {
      return {
        fontSize: '13px',
        color: this.theme.title_color
      }
    },
    tncStyle () {
      return {
        color: this.theme.title_color,
        fontSize: '14px'
      }
    }
  },
  methods: {
  },
  async beforeMount() {
    if (this.$route.query.status == 1 && this.$route.query.refId) {
      this.upgraded_content = this.membershipConfig.upgraded_content
      await this.$store.dispatch('fetchMembershipInfo')
    } else {
      await this.$router.push('welcome')
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
  padding: 0 16px;
}
.middle {
  padding: 2px 4px 2px 2px;
}
.tnc-title {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
}
.tnc {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/membership_purchased.vue